/**
 * Service Worker 註冊與自動更新管理
 */
export default () => {
  if (process.client && 'serviceWorker' in navigator) {
    const registerServiceWorker = async () => {
      try {
        // 註冊 Service Worker
        const registration = await navigator.serviceWorker.register('/sw.js', {
          scope: '/',
          updateViaCache: 'none' // 防止 sw.js 本身被快取
        })

        console.log('✅ SW registered:', registration.scope)

        // 監聽 SW 更新
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing
          if (!newWorker) return

          console.log('🔄 偵測到 SW 更新，開始安裝新版本...')

          newWorker.addEventListener('statechange', () => {
            switch (newWorker.state) {
              case 'installed':
                if (navigator.serviceWorker.controller) {
                  console.log('✨ SW 新版本已安裝，等待啟用')
                } else {
                  console.log('✨ SW 首次安裝完成')
                }
                break
              case 'activated':
                console.log('🎉 SW 已更新並啟用最新版本')
                break
              case 'redundant':
                console.log('⚠️ SW 更新失敗或被取代')
                break
            }
          })
        })

        registration.update()

        // 監聽控制權變更(新 SW 接管頁面)
        let refreshing = false
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          console.log('🔄 SW 控制權已轉移至新版本')
          if (refreshing) return
          const cachedPages = [ // 定義需要在版本更新後重新載入的頁面路徑
            '/home'
          ]
          const currentPath = window.location.pathname.replace(/\/+$/, '') || '/'
          // 僅在快取頁面範圍內自動重新載入
          if (!cachedPages.includes(currentPath)) {
            return
          }
          refreshing = true
          window.location.reload()
        })
      } catch (error) {
        console.error('❌ SW registration failed:', error)
      }
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      registerServiceWorker()
    } else {
      window.addEventListener('DOMContentLoaded', registerServiceWorker)
    }
  }
}
